var React = require('react');

function PlayBtn (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"49","cy":"49","r":"49","fill":"white","fillOpacity":"0.94","key":0}),React.createElement("g",{"clipPath":"url(#clip0_2030_485)","key":1},React.createElement("path",{"d":"M46.2612 35.7527C42.8632 33.5903 38.4167 36.0312 38.4167 40.0589V57.1918C38.4167 61.2194 42.8632 63.6603 46.2612 61.498L59.7228 52.9315C62.8746 50.9258 62.8746 46.3248 59.7228 44.3191L46.2612 35.7527Z","fill":"#042040"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_2030_485"},React.createElement("rect",{"width":"61.25","height":"61.25","fill":"white","transform":"translate(18 18)"})))]);
}

PlayBtn.defaultProps = {"width":"98","height":"98","viewBox":"0 0 98 98","fill":"none"};

module.exports = PlayBtn;

PlayBtn.default = PlayBtn;
